import { DependabotContentPage } from '@mb.io/plugin-github-dependabot';
import { BackstageGuard, GitHubGuard } from '@mercedes-benz/permission';
import { ownershipPermission } from '@mercedes-benz/permission-common';
import { PluginTabWrapper } from './PluginTabWrapper';

export const DependabotTab = () => (
  <PluginTabWrapper>
    <GitHubGuard feature="Dependabot">
      <BackstageGuard permission={ownershipPermission}>
        <DependabotContentPage />
      </BackstageGuard>
    </GitHubGuard>
  </PluginTabWrapper>
);
